AFRAME.registerComponent("init-camera-distance", {
  schema: {
    distance: { type: "number", default: 1 },
  },
  init() {
    this.distance = this.data.distance;
  }
});
